"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function Icon(props) {
    var sizeNumber = '16';
    if (props.size === 'medium') {
        sizeNumber = '20';
    }
    else if (props.size === 'large') {
        sizeNumber = '24';
    }
    var className = "abb_icon_" + sizeNumber + " ui_" + props.icon;
    return (React.createElement("span", { className: className, "aria-hidden": "true", style: { color: props.color } }));
}
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Icon/Icon.js
// module id = 585
// module chunks = 1